export default __webpack_public_path__ + "static/media/011-instant coffee.f264a823.svg";